import { EnvironmentOutlined } from '@ant-design/icons'

export default function MapEmptyState() {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 5,
      }}
    >
      <div
        style={{
          pointerEvents: 'auto',
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderRadius: 16,
          padding: '32px 40px',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.6)',
        }}
      >
        <EnvironmentOutlined style={{ fontSize: 36, color: '#cbd5e1', marginBottom: 12, display: 'block' }} />
        <p style={{ fontSize: 15, fontWeight: 600, color: '#334155', margin: '0 0 4px' }}>
          No location data
        </p>
        <p style={{ fontSize: 13, color: '#94a3b8', margin: 0, maxWidth: 240 }}>
          Location will appear when the device reports GPS coordinates
        </p>
      </div>
    </div>
  )
}
